export default __webpack_public_path__ + "static/media/IMG-20240822-WA0002.ba431d72.jpg";